<i18n src="../../../locales/lang.json"></i18n>

<template>
  <div class="card" v-bind:id="getId()" style="float:left; width:200px; margin-left:15px;">
    <div class="card-header bg-dark text-white header-elements-inline">
      <h6 class="card-title">{{$t('user')}}: {{config.text}}</h6>
      <div class="header-elements">
        <div class="list-icons">
          <a class="list-icons-item" @click="removeMe" data-action="remove"></a>
        </div>
      </div>
    </div>
    <div class="card-body text-center card-img-top" >
      <div class="card-img-actions d-inline-block mb-0">
        <img class="img-fluid rounded-circle" src="/images/user_200x200.jpg" alt="" width="80" height="80">
        <div class="card-img-actions-overlay card-img rounded-circle">
          <a href="#" class="btn btn-outline bg-white text-white border-white border-2 btn-icon rounded-pill">
            <i class="icon-plus3"></i>
          </a>
          <a href="user_pages_profile.html" class="btn btn-outline bg-white text-white border-white border-2 btn-icon rounded-pill ml-2">
            <i class="icon-link"></i>
          </a>
        </div>
      </div>

      <ul class="list-inline list-inline-condensed mt-1 mb-0">
        <li class="list-inline-item">
          <a href="#" class="link-btn btn btn-outline bg-white btn-icon text-white border-white border-2 rounded-round">
            <i class="icon-google-drive"></i>
          </a>
        </li>
        <li class="list-inline-item">
          <a href="#" class="link-btn btn btn-outline bg-white btn-icon text-white border-white border-2 rounded-pill">
            <i class="icon-twitter"></i>
          </a>
        </li>
        <li class="list-inline-item">
          <a href="#" class="link-btn btn btn-outline bg-white btn-icon text-white border-white border-2 rounded-pill">
            <i class="icon-github"></i>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  var config =
  {
    customstyle: "background-color:#92D050",
    customclass: "",
    abbreviation: "T1",
    data: 8,
    text: "Team 1",
    icon: null
  }

  var firstName = "";
  var lastName = "";
  var email = "";

  export default {
    name: "display-contact",
    components: {

    },
    props: {
      enableedit: {
        required: false,
        type: String,
        default: "false"
      },
      type: {
        required: false,
        type: String,
        default: ""
      },
    },
    data() {
      return {
        config,
        firstName,
        lastName,
        email
      };
    },

    methods: {
      getId() {
        return "child_" + this._uid;
      },
      toggleActivation() {

      },
      handleRefresh(val) {
        this.$forceUpdate();
      },
      removeMe() {
        this.$emit('remove', this.getId());
      },
      setConfig(config) {
        this.config = config;
        this.loadData();
      },
      loadData() {
        try {

          var url = `/api/Contacts/v1/${this.config.data}`;
          this.$http.get(url).then(async response => {
            this.firstName = response.FirstName;
            this.lastName = response.LastName;
            this.email = response.Email;
          });
        }
        catch (err) {
          alert('some error:' + err)
        }
      }
    },
    computed: {

    },
    mounted() {

    },

    created: function () {

    },

    watch: {

    },
    created() {
      //this.$root.$on('procedure_refresh', this.handleRefresh);
    },
  };

</script>

<style scoped>

  .card-header.bg-dark {
    background-color: #f6f7f7 !important;
    color: black !important;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .link-btn {
    color: #EAEDEF !important;
    border-color: #EAEDEF !important;
  }

  @media screen and (max-width:768px) {
    .card {
      margin-left: 5px !important;
      width: 185px !important;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/filter/displayers/display-contact.vue